<template>
<div class="product-list-wrapper">
<transition-group name="fadeDown" mode="out-in" tag="table" class="ui very compact table" >

  <tr class=""
      v-for="product in paginatedProducts"
      v-bind:key="product.productId"
      @click="showProductDetails(product.productId)">

    <td class="ui collapsing" >
        <img :src="product.largeImageUrl" class="ui image tiny" qqqstyle="max-height:140px; max-width:100%; height:auto; width:auto; margin:5px auto 1px;">
    </td>
    <td class=" four wide" >
      <div style="max-height:5.5em; overflow:hidden;">
        <span
          v-if="product.productGroupProductIds.length>1"
          class="ui mini circular grey label"
          style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;"
          :data-content="product.productGroupProductIds.length+' variations in this group'" data-position="top left" data-variation="mini">
          {{product.productGroupProductIds.length}}
        </span>
        <i :class="''+product.marketplace.toLowerCase().replace('uk','gb')+' flag'"></i>
        {{product.productTitle}}
      </div>
    </td>


    <td style="line-height:1.8em;">

        <span v-if="reds[product.productGroupId]" class="ui red horizontal label" style="margin-right: 1px; cursor: pointer;">{{reds[product.productGroupId]}} new issue{{reds[product.productGroupId]>1 ? 's' : ' &nbsp;'}}</span>
        <br v-if="reds[product.productGroupId]>0" />
        <span v-if="ambers[product.productGroupId]" class="ui orange horizontal label" style="margin: 0 2px 0 0; cursor: pointer;">{{ambers[product.productGroupId]}} new warn.</span>
    </td>


    <!-- reviews section -->
    <td class="two wide" v-if="product.reviewCount !== null" style="line-height:1.8em;">

      <i class="yellow fitted star icon" v-for="n in starCalc(product.starRating, 'f')"></i><i class="icons" v-for="n in starCalc(product.starRating, 'h')"><i class="yellow fitted star outline icon"></i><i class="yellow fitted half star icon"></i></i><i class="yellow fitted star outline icon" v-for="n in starCalc(product.starRating, 'e')"></i>
        <br />
      <i v-if="$parent.$parent.worldStore.watchDogs && $parent.$parent.worldStore.watchDogs.badReview && $parent.$parent.worldStore.watchDogs.badReview.items && $parent.$parent.worldStore.watchDogs.topReview && $parent.$parent.worldStore.watchDogs.topReview.items && $parent.$parent.worldStore.watchDogs.badReview.items.hasOwnProperty(product.productId)&&$parent.$parent.worldStore.watchDogs.topReview.items.hasOwnProperty(product.productId)&&(($parent.$parent.worldStore.watchDogs.badReview.items[product.productId].status==2&&$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].issueStatus==0)||($parent.$parent.worldStore.watchDogs.topReview.items[product.productId].status==2&&$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].issueStatus==0))" class="fitted red warning icon"></i>
      <i v-else-if="$parent.$parent.worldStore.watchDogs && $parent.$parent.worldStore.watchDogs.badReview && $parent.$parent.worldStore.watchDogs.badReview.items && $parent.$parent.worldStore.watchDogs.topReview && $parent.$parent.worldStore.watchDogs.topReview.items && $parent.$parent.worldStore.watchDogs.badReview.items.hasOwnProperty(product.productId)&&$parent.$parent.worldStore.watchDogs.topReview.items.hasOwnProperty(product.productId)&&(($parent.$parent.worldStore.watchDogs.badReview.items[product.productId].status==1&&$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].issueStatus==0)||($parent.$parent.worldStore.watchDogs.topReview.items[product.productId].status==1&&$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].issueStatus==0))" class="fitted orange warning icon"></i>
      <i v-else> &nbsp; </i>

      {{product.reviewCount}} {{product.reviewCount > 1 ? 'ratings' : 'rating'}}
    </td>
    <td class="" v-else>
        <i style="margin-right: 1px;" class="yellow empty star icon"></i>
        Review data not avail. yet
    </td>


    <!-- sales section -->
    <td class="collapsing" v-if="product.ageHours > -1" style="line-height:1.8em;">
      <div :data-tooltip="'Today: '+product.salesTodayDate+' '+toMonth(product.salesTodayMonth)+' in Amazon ' +product.marketplace+ ' time'">

      <strong>{{salesCountTotal(product.productGroupProductIds, 'y')}}</strong> units sold ystd. <br>
      <strong>{{salesCountTotal(product.productGroupProductIds, 't')}}</strong> so far today ({{product.marketplace}})
      </div>
    </td>
    <td class="" v-else>
        <i style="margin-right: 1px;" class="dollar icon"></i>
        Sales data not avail. yet
    </td>

    <td >
        <div class="chartbutton ui right floated basic brown button" @click.stop.prevent="$parent.$parent.$refs.chartModal.open(product, null)">
        <i class="bar chart icon" style="margin:0;"></i>
      </div>
    </td>

    <!-- BSR section -->
    <td class="" v-if="product.bsrRank !== null" style="line-height:1.8em;">
      BSR
      <small style="color:#aaa;">(24h avg.) </small> <br />
      <span style="color:#a291fb; font-weight:bold;">
        {{product.bsrRank}}
      </span>
    </td>


    <!-- stock section -->
   <td class="three wide" v-if="product.productGroupProductIds.length > 1 && $parent.$parent.worldStore.watchDogs && $parent.$parent.worldStore.watchDogs.inventory && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId]">

        <span v-if="stockReds[product.productGroupId]==0&&stockAmbers[product.productGroupId]==0">

          <span
            class="ui mini circular grey label"
            style="padding-top: .8em !important; min-height: 1em; line-height: .5em; cursor:pointer;"
            :data-content="product.productGroupProductIds.length+' variations in this group'" data-position="top left" data-variation="mini">
            {{product.productGroupProductIds.length}}
          </span>
          <small>SKUs</small>
        </span>
        <span v-else>
          <i class="brown warehouse icon"></i>
          Stock:
          <div v-if="stockReds[product.productGroupId]" style="cursor:pointer;" class="ui tiny compact circular red label"><i class="warning icon"></i>{{stockReds[product.productGroupId]}}</div>
          <div v-if="stockAmbers[product.productGroupId]" style="cursor:pointer;" class="ui tiny compact circular orange label"><i class="warning icon"></i>{{stockAmbers[product.productGroupId]}}</div>
          of <span
            class="ui mini circular  label"
            style="padding-top: .8em !important; min-height: 1em; line-height: .5em; cursor:pointer;"
            :data-content="product.productGroupProductIds.length+' variations in this group'" data-position="top left" data-variation="mini">
            {{product.productGroupProductIds.length}}
          </span> <small>SKUs</small>
        </span>
    </td>
    <td class="three wide" style="line-height:1.8em;" v-if="product.productGroupProductIds.length === 1 && $parent.$parent.worldStore.watchDogs && $parent.$parent.worldStore.watchDogs.inventory && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId]">
        <!--i v-if="FALSE"
          class="green checkmark icon"
          v-show="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.indexOf('No alert thres')===-1&&$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status==0"></i-->

        <i class="green checkmark icon" v-if="$parent.$parent.worldStore.watchDogs && $parent.$parent.worldStore.watchDogs.inventory && $parent.$parent.worldStore.watchDogs.inventory.items && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status==0"></i>
        <i class="orange circle warning icon" v-if="$parent.$parent.worldStore.watchDogs && $parent.$parent.worldStore.watchDogs.inventory && $parent.$parent.worldStore.watchDogs.inventory.items && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status==1"></i>
        <i class="red circle warning checkmark icon" v-if="$parent.$parent.worldStore.watchDogs && $parent.$parent.worldStore.watchDogs.inventory && $parent.$parent.worldStore.watchDogs.inventory.items && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status==2"></i>

        {{$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message ? $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/,.* (\d+)\..*/gi,' ($1 avail.)').replace(/Total in stock/gi,'Stock') : ''}}
        <br/>
        {{$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message ? $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/.*\((.+)\)/gi,'$1').replace(/Total in stock/gi,'Stock').replace(/No alert threshold set;?/,'') : ''}}
    </td>

  </tr>

</transition-group>

<!-- Pagination Controls - Always Visible -->
<div class="ui center aligned segment" style="margin-top: 20px; background-color: #f8f8f8; border: 1px solid #ddd;">
  <div class="ui pagination menu">
    <a class="item" :class="{ disabled: currentPage === 0 }" @click="prevPage">
      <i class="left chevron icon"></i>
    </a>
    
    <!-- Page numbers -->
    <a v-for="page in Math.min(5, totalPages)" :key="page"
       class="item" 
       :class="{ active: currentPage === getPageNumber(page) }"
       @click="goToPage(getPageNumber(page))">
      {{ getPageNumber(page) + 1 }}
    </a>
    
    <a class="item" :class="{ disabled: currentPage >= totalPages - 1 }" @click="nextPage">
      <i class="right chevron icon"></i>
    </a>
  </div>
  
  <div class="ui small message" style="margin-top: 10px;">
    Showing page {{ currentPage + 1 }} of {{ totalPages }} 
    ({{ totalItems }} total products)
    <br>
    DEBUG: groupedProducts={{ groupedProducts ? groupedProducts.length : 'undefined' }}, 
    itemsPerPage={{ itemsPerPage }}, 
    totalPages={{ totalPages }}
  </div>
</div>
</div>
</template>

<script>
import $ from 'jquery'
export default {
  components: {},
  data: function () {
    return {
      reds: {},
      ambers: {},
      stockReds: {},
      stockAmbers: {},
      productGroupId2products: {},
      productGroupIds: [],
      groupedProducts: [],
      // Pagination
      currentPage: 0,
      itemsPerPage: 20,
    }
  },
  props: [],
  methods: {
    toMonth: (m) => ({1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'}[m]),
    salesCountTotal: function (productIds, t) {
      const getSales = id => {
        const product = this.$parent.$parent.worldStore.products[id]
        if (product && product.salesToday !== undefined && product.salesYesterday !== undefined) {
          return {
            today: product.salesToday,
            yesterday: product.salesYesterday
          }
        }
        return null
      }
      if (t === 'y') return productIds.reduce((prevVal, id) => prevVal + (getSales(id) !== null ? getSales(id).yesterday : 0), 0)
      if (t === 't') return productIds.reduce((prevVal, id) => prevVal + (getSales(id) !== null ? getSales(id).today : 0), 0)
    },
    showProductDetails: function (productId) {
      this.$parent.openProductDetailModal(this.sortedUnfoldedProductsIDs, this.sortedUnfoldedProductsIDs.indexOf(productId))
    },
    starCalc: function (r, m) {
      // Add null/undefined checks to prevent RangeError
      if (r === null || r === undefined || isNaN(r)) {
        return m === 'f' ? 0 : m === 'h' ? 0 : m === 'e' ? 5 : 0
      }
      const div = Math.floor(r / 10)
      const mod = r % 10
      if (m === 'f') return Math.max(0, mod <= 7 ? div : div + 1)
      if (m === 'h') return Math.abs(mod - 5) <= 2 ? 1 : 0
      if (m === 'e') return Math.max(0, 5 - div - (mod > 2 ? 1 : 0))
    },
    calc: function (worldStore) {
      // Add null checks to prevent errors
      if (!worldStore || !worldStore.products) {
        console.warn('ProductList: worldStore or products is null/undefined')
        this.groupedProducts = []
        this.productGroupIds = []
        return
      }
      
      const productGroupId2productIds = this.getProductGroupId2productIds(worldStore.products)
      const productId2ProductGroupId = this.getProductId2ProductGroupId(worldStore.products)
      const productGroupIds = Object.keys(productGroupId2productIds)

      // Use pre-calculated alert counts from API if available, otherwise calculate them
      if (worldStore.reds && worldStore.ambers) {
        this.reds = worldStore.reds
        this.ambers = worldStore.ambers
      } else {
        const amberErrorCount = this.getErrorCount(productGroupIds, 1, worldStore.watchDogs, worldStore.products, productId2ProductGroupId)
        const redErrorCount = this.getErrorCount(productGroupIds, 2, worldStore.watchDogs, worldStore.products, productId2ProductGroupId)
        this.reds = redErrorCount.byProductGroupId
        this.ambers = amberErrorCount.byProductGroupId
      }

      const stockAmberErrorCount = worldStore.watchDogs && worldStore.watchDogs.inventory ? this.getWDErrorCount(productGroupIds, 1, worldStore.watchDogs.inventory, worldStore.products, productId2ProductGroupId) : { byProductGroupId: {}, byProductId: {} }
      const stockRedErrorCount = worldStore.watchDogs && worldStore.watchDogs.inventory ? this.getWDErrorCount(productGroupIds, 2, worldStore.watchDogs.inventory, worldStore.products, productId2ProductGroupId) : { byProductGroupId: {}, byProductId: {} }
      this.stockReds = stockRedErrorCount.byProductGroupId
      this.stockAmbers = stockAmberErrorCount.byProductGroupId

      const productGroupId2products = {}
      for (let i = 0; i < productGroupIds.length; ++i) {
        const productGroupId = productGroupIds[i]
        const productIdsForProductGroupId = productGroupId2productIds[productGroupId]
        productGroupId2products[productGroupId] = (this.productGroupId2products.hasOwnProperty(productGroupId)
          ? this.addKeepingOrder(this.productGroupId2products[productGroupId].map(p => p.productId), productGroupId2productIds[productGroupId])
          : productIdsForProductGroupId.sort((a, b) => {
            const redA = this.reds[a] || 0
            const redB = this.reds[b] || 0
            const amberA = this.ambers[a] || 0
            const amberB = this.ambers[b] || 0
            let compResult = redB - redA
            if (compResult !== 0) return compResult
            return amberB - amberA
          })).map(pid => worldStore.products[pid])
      }
      this.productGroupId2products = productGroupId2products
      this.productGroupIds = productGroupIds.sort((a0, b0) => {
        const a = productGroupId2products[a0][0]
        const b = productGroupId2products[b0][0]
        let compResult = b.marketplace.localeCompare(a.marketplace)
        if (compResult !== 0) return compResult
        return a.productTitle.localeCompare(b.productTitle)
      })
      let sortedUnfoldedProductsIDs = []
      for (let i = 0; i < this.productGroupIds.length; ++i) {
        sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs.concat(productGroupId2products[this.productGroupIds[i]].map(p => p.productId))
      }
      this.sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs
      this.groupedProducts = this.productGroupIds.map(pgid => {
        const products = this.productGroupId2products[pgid]
        return products && products.length > 0 ? products[0] : null
      }).filter(p => p !== null)
    },
    getProductGroupId2productIds: function (products) {
      const productGroupId2productIds = {}
      const productValues = Object.values(products)
      for (let i = 0; i < productValues.length; ++i) {
        const product = productValues[i]
        if (productGroupId2productIds[product.productGroupId]) {
          productGroupId2productIds[product.productGroupId].push(product.productId)
        } else {
          productGroupId2productIds[product.productGroupId] = [product.productId]
        }
      }
      return productGroupId2productIds
    },
    getProductId2ProductGroupId: function (products) {
      const result = {}
      const productValues = Object.values(products)
      for (let i = 0; i < productValues.length; ++i) {
        const product = productValues[i]
        result[product.productId] = product.productGroupId
      }
      return result
    },
    getErrorCount: function (productGroupIds, issueStatus, watchDogs, products, productId2ProductGroupId) {
      const productIds = Object.keys(products)
      const errorCountByProductGroupId = {}
      const errorCountByProductId = {}
      for (let i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = new Set()
      }
      for (let i = 0; i < productIds.length; ++i) {
        errorCountByProductId[productIds[i]] = new Set()
      }
      const watchDogKeys = Object.keys(watchDogs)
      for (let i = 0; i < watchDogKeys.length; ++i) {
        const fullKey = watchDogKeys[i]
        const watchDog = watchDogs[fullKey]
        const watchDogName = fullKey.split('_')[0]
        if (watchDog.status === 20 || watchDog.status === 21) continue
        // With flat structure, each watchDog IS an item
        const items = [watchDog]
        for (let j = 0; j < items.length; ++j) {
          const item = items[j]
          if (Array.isArray(item)) {
            for (let k = 0; k < item.length; ++k) {
              const item0 = item[k]
              if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
                if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                  errorCountByProductGroupId[item0.productGroupId].add(watchDogName)
                } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                  errorCountByProductGroupId[productId2ProductGroupId[item0.productId]].add(watchDogName)
                }
                if (item0.productId) {
                  errorCountByProductId[item0.productId].add(watchDogName)
                }
              }
            }
          } else {
            if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
              if (item.productGroupId) {
                errorCountByProductGroupId[item.productGroupId].add(watchDogName)
              } else if (item.productId && productId2ProductGroupId[item.productId]) {
                errorCountByProductGroupId[productId2ProductGroupId[item.productId]].add(watchDogName)
              }
              if (item.productId) {
                errorCountByProductId[item.productId].add(watchDogName)
              }
            }
          }
        }
      }
      const resultByProductId = {}
      const resultByProductGroupId = {}
      for (let i = 0; i < productIds.length; ++i) {
        resultByProductId[productIds[i]] = errorCountByProductId[productIds[i]].size
      }
      for (let i = 0; i < productGroupIds.length; ++i) {
        resultByProductGroupId[productGroupIds[i]] = errorCountByProductGroupId[productGroupIds[i]].size
      }
      return {
        byProductId: resultByProductId,
        byProductGroupId: resultByProductGroupId,
      }
    },
    getWDErrorCount: function (productGroupIds, issueStatus, watchDog, products, productId2ProductGroupId) {
      const productIds = Object.keys(products)
      const errorCountByProductGroupId = {}
      const errorCountByProductId = {}
      for (let i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = 0
      }
      for (let i = 0; i < productIds.length; ++i) {
        errorCountByProductId[productIds[i]] = 0
      }

      const items = Object.values(watchDog.items)
      for (let j = 0; j < items.length; ++j) {
        const item = items[j]
        if (Array.isArray(item)) {
          for (let k = 0; k < item.length; ++k) {
            const item0 = item[k]
            if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
              if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                errorCountByProductGroupId[item0.productGroupId]++
              } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                errorCountByProductGroupId[productId2ProductGroupId[item0.productId]]++
              }
              if (item0.productId) {
                errorCountByProductId[item0.productId]++
              }
            }
          }
        } else {
          if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
            if (item.productGroupId) {
              errorCountByProductGroupId[item.productGroupId]++
            } else if (item.productId && productId2ProductGroupId[item.productId]) {
              errorCountByProductGroupId[productId2ProductGroupId[item.productId]]++
            }
            if (item.productId) {
              errorCountByProductId[item.productId]++
            }
          }
        }
      }

      return {
        byProductId: errorCountByProductId,
        byProductGroupId: errorCountByProductGroupId,
      }
    },
    addKeepingOrder: function (base0, addition0) {
      const base = base0 || []
      const addition = addition0 || []
      const result = []
      for (let i = 0; i < base.length; ++i) {
        if (addition.indexOf(base[i]) >= 0) result.push(base[i])
      }
      const addition2 = []
      for (let i = 0; i < addition.length; ++i) {
        if (base.indexOf(addition[i]) < 0) addition2.push(addition[i])
      }
      const addition3 = addition2.sort()
      for (let i = 0; i < addition3.length; ++i) {
        result.push(addition3[i])
      }
      return result
    },
    // Pagination methods
    prevPage: function () {
      console.log('ProductList prevPage: currentPage before:', this.currentPage)
      if (this.currentPage > 0) {
        this.currentPage--
        console.log('ProductList prevPage: currentPage after:', this.currentPage)
      }
    },
    nextPage: function () {
      console.log('ProductList nextPage: currentPage before:', this.currentPage, 'totalPages:', this.totalPages)
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++
        console.log('ProductList nextPage: currentPage after:', this.currentPage)
      }
    },
    goToPage: function (page) {
      console.log('ProductList goToPage:', page, 'totalPages:', this.totalPages)
      if (page >= 0 && page < this.totalPages) {
        this.currentPage = page
        console.log('ProductList goToPage: currentPage set to:', this.currentPage)
      }
    },
    getPageNumber: function (index) {
      if (this.totalPages <= 5) {
        return index - 1
      }

      let startPage = Math.max(0, this.currentPage - 2)
      let endPage = Math.min(this.totalPages - 1, startPage + 4)

      if (endPage - startPage < 4) {
        startPage = Math.max(0, endPage - 4)
      }

      return startPage + index - 1
    }
  },
  computed: {
    getCardsLayoutSize: function () {
      const n = this.productGroupIds.length
      const w = $(window).width()

      if (n > 4) return w > 1320 ? 'five' : 'four'
      if (n === 4) return w > 1220 ? 'four' : 'three'
      else return w > 1440 ? 'four' : 'three'
    },
    // Pagination computed properties
    totalItems: function () {
      // Add safety checks
      if (!this.groupedProducts || !Array.isArray(this.groupedProducts)) {
        return 0
      }
      
      // Apply filters first to get the correct count for pagination
      const filteredProducts = this.groupedProducts.filter(product => {
        if (!product) return false
        return (this.$parent.filterByMarket.length === 0 || this.$parent.filterByMarket.indexOf(product.marketplace) >= 0) &&
               (this.$parent.filterBySellAcc.length === 0 || this.$parent.filterBySellAcc.indexOf(product.sellerId) >= 0)
      })
      const total = filteredProducts.length
      console.log('ProductList totalItems (filtered):', total)
      return total
    },
    totalPages: function () {
      const pages = Math.ceil(this.totalItems / this.itemsPerPage)
      console.log('ProductList totalPages:', pages, 'itemsPerPage:', this.itemsPerPage)
      return pages
    },
    paginatedProducts: function () {
      // Add safety checks
      if (!this.groupedProducts || !Array.isArray(this.groupedProducts)) {
        console.warn('ProductList: groupedProducts is not an array')
        return []
      }
      
      // First apply filters to get the filtered products
      const filteredProducts = this.groupedProducts.filter(product => {
        if (!product) return false
        return (this.$parent.filterByMarket.length === 0 || this.$parent.filterByMarket.indexOf(product.marketplace) >= 0) &&
               (this.$parent.filterBySellAcc.length === 0 || this.$parent.filterBySellAcc.indexOf(product.sellerId) >= 0)
      })
      
      // Then apply pagination to the filtered results
      const start = this.currentPage * this.itemsPerPage
      const end = start + this.itemsPerPage
      const result = filteredProducts.slice(start, end)
      
      console.log('ProductList paginatedProducts:', result.length, 'currentPage:', this.currentPage, 'start:', start, 'end:', end)
      console.log('ProductList groupedProducts full array length:', this.groupedProducts.length)
      console.log('ProductList filteredProducts length:', filteredProducts.length)
      return result
    },
  },
  mounted: function () {
    $(this.$el).find('.circular[data-content]').popup({ delay: { show: 0, hide: 0 }, transition: 'fade' })
    $('#darkbackgr').stop().fadeOut(200) // in case animation didnt finish in WD view before switching
  },
  watch: {
    '$parent.$parent.worldStore': {
      handler: function (worldStore) {
        this.calc(worldStore)
      },
      deep: true,
    },
  },
  created: function () {
    if (this.$parent.$parent.worldStore) {
      this.calc(this.$parent.$parent.worldStore)
    }
  },
}
</script>

<style>
.flip-list-move {
  transition: transform 1s;
}
#prodCont .ui.segment:first-child {margin-top:12px;}
#prodCont .ui.segment:last-child {margin-bottom:12px;}
/* #prodCont .ui.segment.stacked .extra.content:last-child {padding-bottom:0px;} */

#prodCont .extra.content .chartbutton {opacity:.6; padding: 7px 11px;}
#prodCont .extra.content .chartbutton:hover {opacity:1 !important;}

#prodCont .card:hover {z-index: initial; -webkit-transform: translateY(-2px); transform: translateY(-2px); transition: all 0s;}
</style>



// WEBPACK FOOTER //
// ProductList.vue?69bd0d52